<template>
  <!--
          作者：long
          时间：2023-08-21
          描述：温泉调查-温泉模板
      -->
  <div class="user">
    <!--搜索表单-->
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="问卷名称">
          <el-input v-model="formInline.search" placeholder="请输入问卷调查名称"></el-input>
        </el-form-item>
  
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
        </el-form-item>

        <el-form-item>
          <el-button size="small" @click="batchExport">批量导出</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-table size="small" :data="tableData" @selection-change="handleSelectionChange" border style="width: 100%" v-loading="loading">
          <el-table-column type="selection" width="45"></el-table-column>
          <el-table-column prop="quesire_id" label="ID" ></el-table-column>
          <el-table-column prop="name" label="名称" ></el-table-column>
          <el-table-column prop="intro" label="说明" ></el-table-column>
          <el-table-column prop="nickName" label="发起者头像">
            <template slot-scope="scope" v-if="scope.row.user.avatarUrl">
              <img :src="scope.row.user.avatarUrl"  height="30px" />
            </template>
          </el-table-column>
          <el-table-column prop="" label="发起者">
            <template slot-scope="scope">
              <span>{{scope.row.user.nickName}}</span>
              <span class="gray9">(ID：{{scope.row.rel_id}})</span>
            </template>
          </el-table-column>
          <el-table-column prop="queston_num" label="题目数量" ></el-table-column>
          <el-table-column prop="answer_num" label="答题数量" ></el-table-column>
        
          <el-table-column prop="create_time" label="创建时间" ></el-table-column>
          <el-table-column fixed="right" label="操作" width="90">
            <template slot-scope="scope">
              <el-button @click="checkClick(scope.row)" type="text" size="small" >问卷列表</el-button>
              <el-button @click="deleteClick(scope.row)" type="text" size="small" >删除</el-button>
            </template>
          </el-table-column>

        </el-table>
      </div>
      <!--分页-->
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background
          :current-page="curPage"
          :page-sizes="[20, 100,500, 1000]" 
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"></el-pagination>
      </div>
    </div>

    <Add :open="open_add" :quesire_id="quesire_id"    @close="closeAdd"></Add>

  </div>
</template>

<script>
  import QuesireApi from '@/api/quesire.js';
  import qs from 'qs';
  import Add from './part/Add.vue';
  export default {
    components: {
      Add,
 
    },
    data() {
      return {
        /*是否加载完成*/
        loading: true,
        /*列表数据*/
        tableData: [],
        /*一页多少条*/
        pageSize: 20,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
        /*横向表单数据模型*/
        formInline: {
          search: '',

        },
        /*是否打开添加弹窗*/
        open_add: false,
        quesire_id:""
    
      };
    },
    created() {
      /*获取列表*/
      this.getTableList();
    },
    methods: {
      /*选择第几页*/
      handleCurrentChange(val) {
        let self = this;
        self.curPage = val;
        self.loading = true;
        self.getTableList();
      },

      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1;
        this.pageSize = val;
        this.getTableList();
      },
         /*选择数据*/
    handleSelectionChange(e) {
      this.multipleSelection = e;
    },

      /*获取列表*/
      getTableList() {
        let self = this;
        let Params = self.formInline;
        Params.page = self.curPage;
        Params.list_rows = self.pageSize;
        
        QuesireApi.getData(Params, true)
          .then(res => {
            self.loading = false;
            self.tableData = res.data.list.data;
            self.totalDataNumber = res.data.list.total;
          })
          .catch(error => {
            self.loading = false;
          });
      },
      /*搜索查询*/
      onSubmit() {
        let self = this;
        self.loading = true;
        self.curPage = 1;
        self.getTableList();
      },
      deleteClick(row) {
      let self = this;
      self
        .$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        .then(() => {
          self.loading = true;
          QuesireApi.delQuesire(
            {
              quesire_id: row.quesire_id
            },
            true
          )
            .then(data => {
              self.loading = false;
              if (data.code == 1) {
                self.$message({
                  message: '恭喜你，该管理员删除成功',
                  type: 'success'
                });
                //刷新页面
                self.getTableList();
              } else {
                self.loading = false;
              }
            })
            .catch(error => {
              self.loading = false;
            });
        })
        .catch(() => {});
    },
      batchExport(){//批量导出
        // 勾选需要导出的数据
        let ids = [];
      let params = this.multipleSelection;
      console.log("params",params)
      params.forEach((param)=>{
        ids.push(param.quesire_id);
      })
      ids = ids.join(',');
      // 筛选条件
      // 商品状态
      var parmasa =  this.formInline?this.formInline:{};
      console.log("parmasa",parmasa)
      parmasa["list_rows"] = this.pageSize
      parmasa["page"] = this.curPage
      if(ids.length > 0){
        // console.log(this.searchForm)
        let baseUrl = window.location.protocol + '//' + window.location.host;
        window.location.href = baseUrl + '/index.php/shop/product.product/exportQuesire?' + 
        qs.stringify(parmasa)+'&ids='+ids;
        
      }else{
        this.$message({
            message: '请选择要导出的数据',
            type: 'error'
          });
      }
   

    },

       /*打开添加*/
       checkClick(e) {
      this.open_add=true;
      this.quesire_id = e.quesire_id;
    },

    /*关闭添加*/
    closeAdd(e){
      this.open_add=false;
      if(e.type=='success'){
        this.getTableList();
      }
    },

    }
  };
</script>
<style></style>



// WEBPACK FOOTER //
// src/views/plus/quesire/record.vue